import { useAppSelector } from 'core/store';
import { BRANDS_CONFIGS, BRAND_NAMES } from 'core/whiteLabel/whiteLabel';

export const useWhiteLabel = () => {
  const appVariablesData = useAppSelector((state) => state.appVariables.data);
  const brandName = appVariablesData?.brand || BRAND_NAMES.NETSPARK;

  return BRANDS_CONFIGS[brandName] || {};
};
